import {Observable, ReplaySubject, Scheduler} from "rxjs";
import {ClientEventRecord} from "./models/ClientEventRecord";
import {SseSource} from "../sse/SseSource";
import {ClientEventType} from "./models/ClientEventType";
import {SystemEventService} from "../system-state/SystemEventService";
import {SystemEvent} from "../system-state/SystemEvent";
import {CurrentUserService} from "../user/CurrentUserService";

export class ClientEventService {

    public static id = "clientEventService";

    private readonly events$: Observable<ClientEventRecord>;

    /** @ngInject */
    public constructor(private readonly systemEventService: SystemEventService,
                       private readonly currentUserService: CurrentUserService) {
        if (SseSource.isAvailable()) {
            this.events$ = this.buildEventSource();
        } else {
            // We don't want to use any of the cold Observable creators here as it will cause the stream to end
            // which may break downstream operations, so instead we just return a hot observable that will never emit
            this.events$ = new ReplaySubject(1);
        }
    }

    private buildEventSource(): Observable<ClientEventRecord> {
        const active$ = this.systemEventService
                            .idle()
                            .map((evt) => evt === SystemEvent.IDLE_END)
                            .distinctUntilChanged();

        const loggedIn$ = this.currentUserService
                              .current
                              .map((u) => u.isLoggedIn)
                              .distinctUntilChanged();

        const source$ = Observable.combineLatest(active$, loggedIn$)
                                  .map(([active, loggedIn]) => active && loggedIn);

        return source$.switchMap((active) => this.source(active))
                      .publish()
                      .refCount();
    }

    private source(active: boolean): Observable<ClientEventRecord> {
        if (active) {
            console.debug("Using SSE Source due to user active");
            return SseSource.create<ClientEventRecord>("/tradefloor/api/sse");
        } else {
            console.debug("Using empty event source due to user idle");
            return Observable.empty<ClientEventRecord>();
        }
    }

    public events(): Observable<ClientEventRecord> {
        return this.events$.observeOn(Scheduler.async);
    }
}
